export const baseUrl = 'public/v1/inv';

export const ApiEInvoice = {
  GetData: (id: string) => `${baseUrl}/${id}`,
  ShareFeedBack: `public/v1/feedback`
};
